module.exports = __webpack_public_path__ + "img/对号.0087690f.svg";